import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getComponentViewByInstance } from '@angular/core/src/render3/context_discovery';
import { BehaviorSubject } from 'rxjs';
import { DataAccessService } from '../../shared/services/dataaccess.service';
export class Request{
  RequestID: number;
  FeesAmount: number;
  DegreeApplicableFlag: number;
  ClassApplicableFlag: number;
  SEQUENCENO: number;
  PostAgeinda: number;
  PostAgeaBroad: number;
  UrgentTranscriptFee: number;
  TCFeesAmount: number;
  MCFeesAmount: number;
  YearsLessThaneQualtoten:number;
  BranchChangeApplicationFees: number;
  YearsGreaterThanten:number;
  RequestName:string;
  PostageIndia:string;
  DeleteFlag: string;
  CreatedLoginID: number;
  UpdatedLoginID: number;
  ControllerName:string;
}
@Injectable({
  providedIn: 'root'
})
export class RequestService {

  constructor(
    private dataService: DataAccessService) {
  }
  public GetRequestData() {debugger
    this.dataService.setControllerName = '/PortalBranchChange/';
    this.dataService.setMethodName = 'GetBasicRequest?RequestID=0'; // setting method name from API controller.
    return this.dataService.getAll<Request[]>()
  }

  public GetCheckScheduleForRequest(RequestID,AcademicInstanceID,ExamInstanceID) {debugger
    this.dataService.setControllerName = '/PortalBranchChange/';
    this.dataService.setMethodName = 'CheckRequestSchedule?RequestID='+RequestID+'&AcademicInstanceID='+AcademicInstanceID+'&ExamInstanceID='+ExamInstanceID; // setting method name from API controller.
    return this.dataService.getAll<Request[]>()
  }
}
